import moment from "moment";
import { format, parse } from "date-fns";
import { INSTANCE_URL, DATE_FORMAT } from "Constants";
import { UPDATE_DATE_PROPS } from "GeneralTabAction";
import { getRequest, postRequest, patchRequest } from "NetworkCall";

export var FETCH_EVENT = "fetch_event";
export var FETCH_INTERESTS = "FETCH_INTERESTS";
export var OPEN_INTEREST_MODAL = "OPEN_INTEREST_MODAL";
export var EDIT_INTEREST = "EDIT_INTEREST";
export var FETCH_EVENTSETTINGS = "FETCH_EVENTSETTINGS";
export var LOGGEDINUSER_DATA = "LOGGEDINUSER_DATA";

export function fetchEvent(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?related=clients_by_clientidfk&filter=eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_EVENT, payload: data });

        var eventData = data.resource[0];
        var startDate = `${moment(moment().add(1, "days")).format(
          DATE_FORMAT
        )} 00:00:00`;
        if (eventData && eventData.eventstartdate)
          startDate = `${eventData.eventstartdate} 00:00:00`;

        var endDate = `${moment(moment().add(6, "days")).format(
          DATE_FORMAT
        )} 00:00:00`;
        if (eventData && eventData.eventenddate)
          endDate = `${eventData.eventenddate} 00:00:00`;

        dispatch({
          type: UPDATE_DATE_PROPS,
          payload: {
            from: parse(
              moment(startDate).format("DD-MM-YYYY HH:mm:ss"),
              "dd-MM-yyyy HH:mm:ss",
              new Date()
            ),
            to: parse(
              moment(endDate).format("DD-MM-YYYY HH:mm:ss"),
              "dd-MM-yyyy HH:mm:ss",
              new Date()
            ),
            enteredTo: parse(
              moment(endDate).format("DD-MM-YYYY HH:mm:ss"),
              "dd-MM-yyyy HH:mm:ss",
              new Date()
            ),
          },
          // payload: {
          //   from: new Date(startDate),
          //   to: new Date(endDate),
          //   enteredTo: new Date(endDate),
          // },
          // payload: {
          //   from: moment(startDate),
          //   to: moment(endDate),
          //   enteredTo: moment(endDate),
          // },
        });
        callback({ success: 1, payload: data });
      },
      (error) => {}
    );
  };
}

export function updateEvent(session, data, successCallback, errorCallback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${session.eventid}`;
  var eventid = session.eventid;
  data = { resource: { ...data, eventid } };
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchEvent(session));
        successCallback({ error: 0, data: data });
      },
      (error) => {
        errorCallback({ error: 1, data: error });
      }
    );
  };
}

export function fetchUserInterests(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interests?filter=eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_INTERESTS, payload: data });
      },
      (error) => {}
    );
  };
}

export function openInterestModal(status, interestObject = {}) {
  return {
    type: OPEN_INTEREST_MODAL,
    payload: { status: status, interest: interestObject },
  };
}

export function editInterest(interestObject = {}) {
  return {
    type: EDIT_INTEREST,
    payload: interestObject,
  };
}

export function updateUserInterest(
  session,
  data,
  successCallback,
  errorCallback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/interests?filter=interestid=${data.interestid}`;
  var eventid = session.eventid;
  data = { resource: { ...data, eventid } };
  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        successCallback({ error: 0, data: data });
        dispatch(fetchUserInterests(session));
      },
      (error) => {
        errorCallback({ error: 1, data: error });
      }
    );
  };
}

export function addUserInterests(session, values, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/addInterests`;
  var body = {
    interests: values,
    eventid: session.eventid,
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(openInterestModal(false));
        dispatch(fetchUserInterests(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function chatInvitesStatus(session, chatStatus, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${session.eventid}`;
  let data = { resource: { chatinvites: chatStatus } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchEvent(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function showUserCountStatus(session, status, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=eventid=${session.eventid}`;
  let data = { resource: { shownetworkingusercount: status } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchEvent(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function fetchEventSettings(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_EVENTSETTINGS, payload: data });
      },
      (error) => {}
    );
  };
}

export function sortAttendeeListStatus(session, status, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?filter=eventid=${session.eventid}`;
  let data = { resource: { attendeesort: status } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        dispatch(fetchEventSettings(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, error: error });
      }
    );
  };
}

export function updateChatthreadRequest(session, callback) {
  var filter = encodeURI(
    `(eventid=${session.eventid}) AND (newrequesterstatus=requested)`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/chatthread?filter=(${filter})`;
  let data = { resource: { newrequesterstatus: "accepted" } };

  return (dispatch) => {
    patchRequest(
      url,
      data,
      session,
      dispatch,
      (data) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function fetchLoggedinuser(session) {
  var filter = encodeURI(
    `((appuserid=${session.userid})AND(eventid=${session.eventid}))`
  );
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(${filter})`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (res) => {
        dispatch({
          type: LOGGEDINUSER_DATA,
          payload: { data: res.resource },
        });
      },
      (error) => {}
    );
  };
}
